// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerWalletTransactionsSortOrder = {
    Ascending: 'Ascending',
    Descending: 'Descending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerWalletTransactionsOrderingType = {
    ByPeriod: 'ByPeriod',
    ByTransactionDate: 'ByTransactionDate',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCommissionPlansSuccessPlanCustomerDownlineBasicOverviewDownlineType = {
    Full: 'Full',
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
    PersonalGroupPlusPgLeadersInFirstLevel: 'PersonalGroupPlusPgLeadersInFirstLevel',
    PersonalGroupPlusAllPgLeaders: 'PersonalGroupPlusAllPgLeaders',
    PgLeaders: 'PgLeaders',
    FirstLevelPlusAllEndCustomers: 'FirstLevelPlusAllEndCustomers',
    PersonalGroupPlusAuthorizedPgLeadersInFirstLevel: 'PersonalGroupPlusAuthorizedPgLeadersInFirstLevel',
    FirstLevelAuthorizedPgLeaders: 'FirstLevelAuthorizedPgLeaders',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCommissionPlansSuccessPlanCustomerDownlineOnlyIdDownlineType = {
    Full: 'Full',
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
    PersonalGroupPlusPgLeadersInFirstLevel: 'PersonalGroupPlusPgLeadersInFirstLevel',
    PersonalGroupPlusAllPgLeaders: 'PersonalGroupPlusAllPgLeaders',
    PgLeaders: 'PgLeaders',
    FirstLevelPlusAllEndCustomers: 'FirstLevelPlusAllEndCustomers',
    PersonalGroupPlusAuthorizedPgLeadersInFirstLevel: 'PersonalGroupPlusAuthorizedPgLeadersInFirstLevel',
    FirstLevelAuthorizedPgLeaders: 'FirstLevelAuthorizedPgLeaders',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerSponsorChangeCandidatesCustomerRegistrationType = {
    SelfBrandPartner: 'SelfBrandPartner',
    SelfVip: 'SelfVip',
    SponsorBrandPartner: 'SponsorBrandPartner',
    SponsorVip: 'SponsorVip',
    Checkout: 'Checkout',
    SponsorOnBehalf: 'SponsorOnBehalf',
    SelfOnBehalf: 'SelfOnBehalf',
    SocialNetworks: 'SocialNetworks',
    SelfOnBehalfVip: 'SelfOnBehalfVip',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetApplicationsSocialMediaLibraryStatsSortBy = {
    Favorite: 'Favorite',
    Like: 'Like',
    Visit: 'Visit',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetApplicationsSocialMediaLibraryStatsSortType = {
    Ascending: 'Ascending',
    Descending: 'Descending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionMessagesType = {
    ShoppingBag: 'ShoppingBag',
    Offers: 'Offers',
    Delivery: 'Delivery',
    Review: 'Review',
    Notifications: 'Notifications',
    Restrictions: 'Restrictions',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetApplicationsCustomerFeedbackCustomerUnreviewedProductsSort = {
    Latest: 'Latest',
    Oldest: 'Oldest',
    ProductNameAscending: 'ProductNameAscending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetRequiredTermsTermsType = {
    TermsAndConditions: 'TermsAndConditions',
    PrivacyPolicy: 'PrivacyPolicy',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetRequiredTermsTermsCustomerType = {
    Consultant: 'Consultant',
    EndCustomer: 'EndCustomer',
    VipCustomer: 'VipCustomer',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetRequestValidationMetadataAction = {
    Registration: 'Registration',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetProductRelationsRelationTypesItem = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
    Popular: 'Popular',
    Favourite: 'Favourite',
    Samples: 'Samples',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetConsultantsMetadataXProcessContext = {
    Standard: 'Standard',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateConsultantXProcessContext = {
    Standard: 'Standard',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetDigitalPromotionsChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetDigitalPromotionsPromotionTypesItem = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerProfileMetadataXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdateCustomerProfileXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerProfileXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetProductsLabelsProductLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerPhonesMetadataXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var DeleteCustomerPhoneXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdateCustomerPhoneXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerPhoneXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerPhonesXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionPersonalSubscriptionsStatusFilter = {
    New: 'New',
    Pending: 'Pending',
    Dropped: 'Dropped',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetPeriodTasksType = {
    Closing: 'Closing',
    Opening: 'Opening',
    PreClosing: 'PreClosing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetPendingRegistrationsMetadataXProcessContext = {
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreatePendingRegistrationXProcessContext = {
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdatePendingRegistrationXProcessContext = {
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetPendingRegistrationXProcessContext = {
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetOrderPaymentProvidersEvaluationFilterType = {
    All: 'All',
    Allowed: 'Allowed',
    Blocked: 'Blocked',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionPaymentProvidersEvaluationFilterType = {
    All: 'All',
    Allowed: 'Allowed',
    Blocked: 'Blocked',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetOrderPaymentMethodsEvaluationFilterType = {
    All: 'All',
    Allowed: 'Allowed',
    Blocked: 'Blocked',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerOriflameCardCardResultType = {
    ForPrint: 'ForPrint',
    Thumbnail: 'Thumbnail',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerOrdersLastUnpaidOrderOriginType = {
    Online: 'Online',
    Vip: 'Vip',
    Telephone: 'Telephone',
    Email: 'Email',
    Immediate: 'Immediate',
    Automatic: 'Automatic',
    Registration: 'Registration',
    Other: 'Other',
    Pharmacy: 'Pharmacy',
    Pbs: 'Pbs',
    WeChat: 'WeChat',
    WeChatApp: 'WeChatApp',
    NowApp: 'NowApp',
    Bambuser: 'Bambuser',
    VendingMachine: 'VendingMachine',
    Demo: 'Demo',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetOrdersStatus = {
    All: 'All',
    Paid: 'Paid',
    Unpaid: 'Unpaid',
    CreditNote: 'CreditNote',
    Pending: 'Pending',
    Canceled: 'Canceled',
    Blocked: 'Blocked',
    Waiting: 'Waiting',
    CancelRequested: 'CancelRequested',
    WaitingForApproval: 'WaitingForApproval',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetOrdersHistoryType = {
    Last3Periods: 'Last3Periods',
    Full: 'Full',
    Claimable: 'Claimable',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerMenuOrderType = {
    Blocked: 'Blocked',
    Registration: 'Registration',
    TeamLeader: 'TeamLeader',
    TeamMember: 'TeamMember',
    Normal: 'Normal',
    PreOrder: 'PreOrder',
    PrePreOrder: 'PrePreOrder',
    Supplementary: 'Supplementary',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCommissionPlanTypesSuccessPlanCustomerManagerSeminarsCustomerCategoryFilter = {
    All: 'All',
    Consultants: 'Consultants',
    EndCustomers: 'EndCustomers',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCommissionPlanTypesSuccessPlanCustomerManagerSeminarsDownlineType = {
    Full: 'Full',
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
    PersonalGroupPlusPgLeadersInFirstLevel: 'PersonalGroupPlusPgLeadersInFirstLevel',
    PersonalGroupPlusAllPgLeaders: 'PersonalGroupPlusAllPgLeaders',
    PgLeaders: 'PgLeaders',
    FirstLevelPlusAllEndCustomers: 'FirstLevelPlusAllEndCustomers',
    PersonalGroupPlusAuthorizedPgLeadersInFirstLevel: 'PersonalGroupPlusAuthorizedPgLeadersInFirstLevel',
    FirstLevelAuthorizedPgLeaders: 'FirstLevelAuthorizedPgLeaders',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCommissionPlanTypesSuccessPlanCustomerManagerSeminarsCustomerFilter = {
    All: 'All',
    NewStarters: 'NewStarters',
    NewStartersHist: 'NewStartersHist',
    Recruits: 'Recruits',
    RecruitsHist: 'RecruitsHist',
    NewStarterOrRecruit: 'NewStarterOrRecruit',
    NewStarterOrRecruitHist: 'NewStarterOrRecruitHist',
    Starters: 'Starters',
    ActiveInPeriod: 'ActiveInPeriod',
    ClosingSalesForce: 'ClosingSalesForce',
    Sleeping: 'Sleeping',
    SalesForce: 'SalesForce',
    InactiveInPeriod: 'InactiveInPeriod',
    Inactive1Period: 'Inactive1Period',
    Inactive2Period: 'Inactive2Period',
    Inactive3Period: 'Inactive3Period',
    Leaders: 'Leaders',
    Reactivated: 'Reactivated',
    Active: 'Active',
    ActiveClose: 'ActiveClose',
    SalesForceEndCustomers: 'SalesForceEndCustomers',
    ActiveInPeriodWithoutRecruitsAndReactivated: 'ActiveInPeriodWithoutRecruitsAndReactivated',
    EndCustomersActiveInPeriodWithoutRecruitsAndReactivated: 'EndCustomersActiveInPeriodWithoutRecruitsAndReactivated',
    FirstBpEndCustomer: 'FirstBpEndCustomer',
    ReactivatedEndCustomer: 'ReactivatedEndCustomer',
    SleepingEndCustomer: 'SleepingEndCustomer',
    NewStarterOrNewEndCustomerOrRecruitOrFirstBpEndCustomerHist: 'NewStarterOrNewEndCustomerOrRecruitOrFirstBpEndCustomerHist',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerInAppNotificationSeenXClientPlatform = {
    Ios: 'Ios',
    Android: 'Android',
    WebDesktop: 'WebDesktop',
    WebMobile: 'WebMobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerInAppNotificationsSeenXClientPlatform = {
    Ios: 'Ios',
    Android: 'Android',
    WebDesktop: 'WebDesktop',
    WebMobile: 'WebMobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var DeleteCustomerInAppNotificationXClientPlatform = {
    Ios: 'Ios',
    Android: 'Android',
    WebDesktop: 'WebDesktop',
    WebMobile: 'WebMobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerInAppNotificationsViewedXClientPlatform = {
    Ios: 'Ios',
    Android: 'Android',
    WebDesktop: 'WebDesktop',
    WebMobile: 'WebMobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerInAppNotificationViewedXClientPlatform = {
    Ios: 'Ios',
    Android: 'Android',
    WebDesktop: 'WebDesktop',
    WebMobile: 'WebMobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerInAppNotificationsSortType = {
    Ascending: 'Ascending',
    Descending: 'Descending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetInAppNotificationsSortType = {
    Ascending: 'Ascending',
    Descending: 'Descending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetEndConsumerOrdersOrderStatus = {
    Pending: 'Pending',
    Added: 'Added',
    Ordered: 'Ordered',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerEmailsMetadataXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var DeleteCustomerEmailXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerEmailXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerEmailsXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetEditorialArticlesArticleType = {
    Undefined: 'Undefined',
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerDownlineCustomersXDownlinePermission = {
    Profile: 'Profile',
    General: 'General',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerDocumentApprovalsApprovalStatesItem = {
    Pending: 'Pending',
    Rejected: 'Rejected',
    Approved: 'Approved',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionDeliveryOptionsFilter = {
    History: 'History',
    MyHistoryAddresses: 'MyHistoryAddresses',
    MyHistoryFriends: 'MyHistoryFriends',
    PickUp: 'PickUp',
    MySpo: 'MySpo',
    PremiumSpo: 'PremiumSpo',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
    AllAddresses: 'AllAddresses',
    MyAddresses: 'MyAddresses',
    MyFriends: 'MyFriends',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionDeliveryFiltersFilterGroup = {
    Default: 'Default',
    History: 'History',
    AddressBook: 'AddressBook',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionClusteredPickupPointsFilter = {
    All: 'All',
    PickupPoint: 'PickupPoint',
    MySpo: 'MySpo',
    PremiumSpo: 'PremiumSpo',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionClusteredPickupPointsMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionDeliveryChannelsFilter = {
    All: 'All',
    PickupPoint: 'PickupPoint',
    MySpo: 'MySpo',
    PremiumSpo: 'PremiumSpo',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetShoppingSessionDeliveryChannelsMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerRequiredTermsTermsType = {
    TermsAndConditions: 'TermsAndConditions',
    PrivacyPolicy: 'PrivacyPolicy',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerRelationshipsType = {
    FavoriteContact: 'FavoriteContact',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdateCustomerRegistrationInstructionXProcessContext = {
    Standard: 'Standard',
    OnBehalfRegistration: 'OnBehalfRegistration',
    OnBehalfOrder: 'OnBehalfOrder',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerProductsLabelsProductLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerConceptLabelsConceptLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerActivityActivityType = {
    CompleteProfile: 'CompleteProfile',
    Onboarding: 'Onboarding',
    LearningActivity: 'LearningActivity',
    BrowseCatalogue: 'BrowseCatalogue',
    DailyHearts: 'DailyHearts',
    SkinDiagnosis: 'SkinDiagnosis',
    VisitPage: 'VisitPage',
    VisitQuiz: 'VisitQuiz',
    VisitBanner: 'VisitBanner',
    VisitSocial: 'VisitSocial',
    Campaign2Order: 'Campaign2Order',
    FirstOrder: 'FirstOrder',
    WpOrder: 'WpOrder',
    Campaign3Order: 'Campaign3Order',
    Campaign4Order: 'Campaign4Order',
    Campaign5Order: 'Campaign5Order',
    Campaign6Order: 'Campaign6Order',
    PayRevolut: 'PayRevolut',
    SubscribeWellosophy: 'SubscribeWellosophy',
    SharingDiscount: 'SharingDiscount',
    ShareProduct: 'ShareProduct',
    ShareCatalogue: 'ShareCatalogue',
    SharingApp: 'SharingApp',
    SharePost: 'SharePost',
    ShareLink: 'ShareLink',
    RecruitOrder: 'RecruitOrder',
    RecruitWp: 'RecruitWp',
    FirstRecruit: 'FirstRecruit',
    RecruitWithProduct: 'RecruitWithProduct',
    TpsOnboarding: 'TpsOnboarding',
    TpsProgramPlus: 'TpsProgramPlus',
    TpsAdvancementBonus: 'TpsAdvancementBonus',
    TpsSummit: 'TpsSummit',
    TpsMyWhy: 'TpsMyWhy',
    NovAgePurchase: 'NovAgePurchase',
    ProductPurchase: 'ProductPurchase',
    OpenMv7: 'OpenMv7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetConceptLabelsConceptLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimSessionDeliveryChannelsMethod = {
    PickupPoint: 'PickupPoint',
    Home: 'Home',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
    NextOrder: 'NextOrder',
    ParcelLocker: 'ParcelLocker',
    NearestPostOffice: 'NearestPostOffice',
    LastUsed: 'LastUsed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimCategoryScenariosClaimAction = {
    ReturnProduct: 'ReturnProduct',
    ExchangeProduct: 'ExchangeProduct',
    CancelProduct: 'CancelProduct',
    ResendProduct: 'ResendProduct',
    CancelOrder: 'CancelOrder',
    ResendOrder: 'ResendOrder',
    None: 'None',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimCategoryScenariosClaimCause = {
    AdverseReaction: 'AdverseReaction',
    UnwantedProduct: 'UnwantedProduct',
    DamagedOrDefectedProduct: 'DamagedOrDefectedProduct',
    MissingProduct: 'MissingProduct',
    WrongProductDelivered: 'WrongProductDelivered',
    ParcelNotDelivered: 'ParcelNotDelivered',
    ParcelDamaged: 'ParcelDamaged',
    ParcelRefused: 'ParcelRefused',
    InvoiceCampaignProductMissing: 'InvoiceCampaignProductMissing',
    InvoiceWrongPriceOrFee: 'InvoiceWrongPriceOrFee',
    CancelOrder: 'CancelOrder',
    RefundReturnCost: 'RefundReturnCost',
    WrongPriceFix: 'WrongPriceFix',
    SupplementaryProduct: 'SupplementaryProduct',
    ExtraProductReceivedMissingOnTheInvoice: 'ExtraProductReceivedMissingOnTheInvoice',
    ExtraProductReceivedWrongQuantity: 'ExtraProductReceivedWrongQuantity',
    UncollectedParcel: 'UncollectedParcel',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimCategoriesClaimType = {
    ReturnExchangeOrMissingProduct: 'ReturnExchangeOrMissingProduct',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimDeliveryChannelsMethod = {
    PickupPoint: 'PickupPoint',
    Home: 'Home',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
    NextOrder: 'NextOrder',
    ParcelLocker: 'ParcelLocker',
    NearestPostOffice: 'NearestPostOffice',
    LastUsed: 'LastUsed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimsStatus = {
    Created: 'Created',
    Saved: 'Saved',
    PartiallyApproved: 'PartiallyApproved',
    Approved: 'Approved',
    Denied: 'Denied',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimsClaimCategory = {
    Root: 'Root',
    ReturnExchangeMissing: 'ReturnExchangeMissing',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
    Return: 'Return',
    Exchange: 'Exchange',
    Missing: 'Missing',
    WrongProductDelivered: 'WrongProductDelivered',
    ProductJustMissing: 'ProductJustMissing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetClaimsCustomerType = {
    BrandPartners: 'BrandPartners',
    Customers: 'Customers',
    Employees: 'Employees',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCampaignsCampaignType = {
    InvitedRecruits: 'InvitedRecruits',
    Loyalty: 'Loyalty',
    VipLoyalty: 'VipLoyalty',
    Mgm: 'Mgm',
    LightVipLoyalty: 'LightVipLoyalty',
    MmLoyalty: 'MmLoyalty',
    Gamification: 'Gamification',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerBlockingsBlockingState = {
    Valid: 'Valid',
    Expired: 'Expired',
    Future: 'Future',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetBlockingCodesBlockingType = {
    Login: 'Login',
    Recruit: 'Recruit',
    Order: 'Order',
    OrderOnCredit: 'OrderOnCredit',
    GetBonuses: 'GetBonuses',
    Claim: 'Claim',
    PayByCheque: 'PayByCheque',
    ApproveDocument: 'ApproveDocument',
    PageAccess: 'PageAccess',
    Other: 'Other',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerApprovalMetadataXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerApprovalXProcessContext = {
    Profile: 'Profile',
    Checkout: 'Checkout',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreatePaymentPaymentProvidersAdyenPaymentDeprecatedXPaymentChannel = {
    IOS: 'IOS',
    Android: 'Android',
    Web: 'Web',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreatePaymentProvidersAdyenPaymentXPaymentChannel = {
    IOS: 'IOS',
    Android: 'Android',
    Web: 'Web',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetPaymentPaymentProvidersAdyenPaymentMethodsDeprecatedXPaymentChannel = {
    IOS: 'IOS',
    Android: 'Android',
    Web: 'Web',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetPaymentProvidersAdyenPaymentPaymentMethodsXPaymentChannel = {
    IOS: 'IOS',
    Android: 'Android',
    Web: 'Web',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerAddressesMetadataXProcessContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerAddressesMetadataXAddressFormContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var DeleteCustomerAddressXProcessContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdateCustomerAddressXProcessContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var UpdateCustomerAddressXAddressFormContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerAddressXProcessContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateCustomerAddressXAddressFormContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerAddressesXProcessContext = {
    Profile: 'Profile',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetCustomerAddressesTypesFilterItem = {
    Home: 'Home',
    Channel: 'Channel',
    Delivery: 'Delivery',
    Other: 'Other',
    Kyc: 'Kyc',
    Subscription: 'Subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CreateAccountsMySendTemporaryPasswordChannelsItem = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var OptionalNullableNotificationChannelValue = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var OptionalNullableCustomerRegistrationSponsorOriginValue = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
    Pbs: 'Pbs',
    ReferralLink: 'ReferralLink',
    InternationalPbs: 'InternationalPbs',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var OptionalNullableCustomerGenderValue = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalVouchersVoucherDtoFlagsItem = {
    Personal: 'Personal',
    ShareWithFriends: 'ShareWithFriends',
    UnlimitedUse: 'UnlimitedUse',
    MultiUse: 'MultiUse',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestUpgradeRequestDtoConsultantType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
    DirectSeller: 'DirectSeller',
    SpoOwner: 'SpoOwner',
    Agent: 'Agent',
    Corporate: 'Corporate',
    LegacyConsultant: 'LegacyConsultant',
    LegacyManager: 'LegacyManager',
    FamilyContractor: 'FamilyContractor',
    LegacyDirector: 'LegacyDirector',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestUpgradeRequestDtoCurrentStep = {
    PersonalDetails: 'PersonalDetails',
    ELearning: 'ELearning',
    Congratulation: 'Congratulation',
    JoiningFee: 'JoiningFee',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestUpgradeRequestDtoStatus = {
    NotStarted: 'NotStarted',
    Pending: 'Pending',
    Completed: 'Completed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestUpgradeRequestDtoActivationType = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestUpgradeRequestDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalUpgradeRequestMetadataUpgradeSharedMetadataDtoAvailableConsultantTypesItem = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
    DirectSeller: 'DirectSeller',
    SpoOwner: 'SpoOwner',
    Agent: 'Agent',
    Corporate: 'Corporate',
    LegacyConsultant: 'LegacyConsultant',
    LegacyManager: 'LegacyManager',
    FamilyContractor: 'FamilyContractor',
    LegacyDirector: 'LegacyDirector',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalTermsRequiredTermDtoTermsCustomerType = {
    Consultant: 'Consultant',
    EndCustomer: 'EndCustomer',
    VipCustomer: 'VipCustomer',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalTermsRequiredTermDtoType = {
    TermsAndConditions: 'TermsAndConditions',
    PrivacyPolicy: 'PrivacyPolicy',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingVoucherDtoPromotionType = {
    Unknown: 'Unknown',
    PromoCode: 'PromoCode',
    CustomerPromoCode: 'CustomerPromoCode',
    RecommendAFriend: 'RecommendAFriend',
    FreeShipping: 'FreeShipping',
    PercentageDiscount: 'PercentageDiscount',
    FixedDiscount: 'FixedDiscount',
    Mgm: 'Mgm',
    Referral: 'Referral',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingUnpaidOrderDtoOrigin = {
    Online: 'Online',
    Vip: 'Vip',
    Telephone: 'Telephone',
    Email: 'Email',
    Immediate: 'Immediate',
    Automatic: 'Automatic',
    Registration: 'Registration',
    Other: 'Other',
    Pharmacy: 'Pharmacy',
    Pbs: 'Pbs',
    WeChat: 'WeChat',
    WeChatApp: 'WeChatApp',
    NowApp: 'NowApp',
    Bambuser: 'Bambuser',
    VendingMachine: 'VendingMachine',
    Demo: 'Demo',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingSubscriptionDtoStatus = {
    Created: 'Created',
    Renewed: 'Renewed',
    Closed: 'Closed',
    Canceled: 'Canceled',
    Autocanceled: 'Autocanceled',
    Reactivated: 'Reactivated',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingSessionDtoOrigin = {
    Online: 'Online',
    Vip: 'Vip',
    Telephone: 'Telephone',
    Email: 'Email',
    Immediate: 'Immediate',
    Automatic: 'Automatic',
    Internal: 'Internal',
    Registration: 'Registration',
    Other: 'Other',
    Pharmacy: 'Pharmacy',
    Pbs: 'Pbs',
    WeChat: 'WeChat',
    WeChatApp: 'WeChatApp',
    NowApp: 'NowApp',
    Bambuser: 'Bambuser',
    VendingMachine: 'VendingMachine',
    Demo: 'Demo',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingMessageDtoAppearance = {
    ShopppingBag: 'ShopppingBag',
    Information: 'Information',
    Offers: 'Offers',
    Delivery: 'Delivery',
    Payments: 'Payments',
    Beauty: 'Beauty',
    Review: 'Review',
    Subscriptions: 'Subscriptions',
    All: 'All',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingMessageDtoHintCategory = {
    General: 'General',
    EndConsumerOrders: 'EndConsumerOrders',
    BackOrders: 'BackOrders',
    Campaign: 'Campaign',
    Offer: 'Offer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingMessageDtoType = {
    Information: 'Information',
    Alert: 'Alert',
    Generated: 'Generated',
    Advice: 'Advice',
    Delivery: 'Delivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingDtoOrigin = {
    Online: 'Online',
    Vip: 'Vip',
    Telephone: 'Telephone',
    Email: 'Email',
    Immediate: 'Immediate',
    Automatic: 'Automatic',
    Internal: 'Internal',
    Registration: 'Registration',
    Other: 'Other',
    Pharmacy: 'Pharmacy',
    Pbs: 'Pbs',
    WeChat: 'WeChat',
    WeChatApp: 'WeChatApp',
    NowApp: 'NowApp',
    Bambuser: 'Bambuser',
    VendingMachine: 'VendingMachine',
    Demo: 'Demo',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingBagAggregatedItemDtoBackorderStatus = {
    None: 'None',
    Allowed: 'Allowed',
    Requested: 'Requested',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingBagAggregatedItemDtoProductFlag = {
    None: 'None',
    New: 'New',
    OutOfStock: 'OutOfStock',
    ComingSoon: 'ComingSoon',
    NotSoldOnline: 'NotSoldOnline',
    LastChance: 'LastChance',
    SoldOut: 'SoldOut',
    NoLongerForSale: 'NoLongerForSale',
    Offer: 'Offer',
    ValueSet: 'ValueSet',
    LowStock: 'LowStock',
    SaleLimitation: 'SaleLimitation',
    FreeSample: 'FreeSample',
    Loyalty: 'Loyalty',
    Claim: 'Claim',
    OverProductSalesLimit: 'OverProductSalesLimit',
    Replacement: 'Replacement',
    PartiallyOutOfStock: 'PartiallyOutOfStock',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingShoppingBagAggregatedItemDtoItemType = {
    Product: 'Product',
    Reservation: 'Reservation',
    Offer: 'Offer',
    Bundle: 'Bundle',
    PersonalNutrition: 'PersonalNutrition',
    MerchandisingDiscount: 'MerchandisingDiscount',
    MerchandisingChange: 'MerchandisingChange',
    MerchandisingGift: 'MerchandisingGift',
    MerchandisingChangedGift: 'MerchandisingChangedGift',
    Service: 'Service',
    NextOrderDelivery: 'NextOrderDelivery',
    Subscription: 'Subscription',
    PersonalSubscription: 'PersonalSubscription',
    BackOrder: 'BackOrder',
    EndConsumerOrder: 'EndConsumerOrder',
    Replacement: 'Replacement',
    Target: 'Target',
    FreeSample: 'FreeSample',
    Section1: 'Section1',
    Section2: 'Section2',
    Section3: 'Section3',
    Section4: 'Section4',
    Donation: 'Donation',
    Fee: 'Fee',
    PaymentFee: 'PaymentFee',
    RegistrationFee: 'RegistrationFee',
    Voucher: 'Voucher',
    StarterKit: 'StarterKit',
    RenewalFee: 'RenewalFee',
    ExtraSold: 'ExtraSold',
    ExtraChange: 'ExtraChange',
    FreeShippingJoker: 'FreeShippingJoker',
    ExtraTax: 'ExtraTax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingSectionItemDtoInvalidationReason = {
    NotAvailable: 'NotAvailable',
    OutOfStock: 'OutOfStock',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingReferralDtoReferralType = {
    None: 'None',
    Pbs: 'Pbs',
    Mgm: 'Mgm',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingPersonalSubscriptionDtoStatus = {
    New: 'New',
    Pending: 'Pending',
    Dropped: 'Dropped',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingPaymentProviderDtoBlockReason = {
    Terminated: 'Terminated',
    OverdueOrders: 'OverdueOrders',
    CantOrder: 'CantOrder',
    PendingLimit: 'PendingLimit',
    CreditLimit: 'CreditLimit',
    UnpaidInterest: 'UnpaidInterest',
    CantOrderOnCredit: 'CantOrderOnCredit',
    CodUnpaidLimit: 'CodUnpaidLimit',
    WftUnpaidLimit: 'WftUnpaidLimit',
    CardUnpaidLimit: 'CardUnpaidLimit',
    CrossBranch: 'CrossBranch',
    CreditUnpaidLimit: 'CreditUnpaidLimit',
    CashUnpaidLimit: 'CashUnpaidLimit',
    VipTotalUnpaidLimit: 'VipTotalUnpaidLimit',
    CustomerTotalUnpaidLimit: 'CustomerTotalUnpaidLimit',
    MaxAmount: 'MaxAmount',
    MinAmount: 'MinAmount',
    WftUnpaidLimitBlockingOthers: 'WftUnpaidLimitBlockingOthers',
    CreditUnpaidLimitBlockingOthers: 'CreditUnpaidLimitBlockingOthers',
    CardUnpaidLimitBlockingOthers: 'CardUnpaidLimitBlockingOthers',
    CodUnpaidLimitBlockingOthers: 'CodUnpaidLimitBlockingOthers',
    CashUnpaidLimitBlockingOthers: 'CashUnpaidLimitBlockingOthers',
    EmptyUniqueId: 'EmptyUniqueId',
    MissingCustomerEmail: 'MissingCustomerEmail',
    NotAllowedRecurringForVipOrder: 'NotAllowedRecurringForVipOrder',
    MissingCustomerBirthDate: 'MissingCustomerBirthDate',
    MissingCustomerTelephone: 'MissingCustomerTelephone',
    TelephoneNumberIsNotValid: 'TelephoneNumberIsNotValid',
    OneStepProviderNotAllowedForOob: 'OneStepProviderNotAllowedForOob',
    ZeroDebt: 'ZeroDebt',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingPaymentMethodDtoBlockReason = {
    Terminated: 'Terminated',
    OverdueOrders: 'OverdueOrders',
    CantOrder: 'CantOrder',
    PendingLimit: 'PendingLimit',
    CreditLimit: 'CreditLimit',
    UnpaidInterest: 'UnpaidInterest',
    CantOrderOnCredit: 'CantOrderOnCredit',
    CodUnpaidLimit: 'CodUnpaidLimit',
    WftUnpaidLimit: 'WftUnpaidLimit',
    CardUnpaidLimit: 'CardUnpaidLimit',
    CrossBranch: 'CrossBranch',
    CreditUnpaidLimit: 'CreditUnpaidLimit',
    CashUnpaidLimit: 'CashUnpaidLimit',
    VipTotalUnpaidLimit: 'VipTotalUnpaidLimit',
    CustomerTotalUnpaidLimit: 'CustomerTotalUnpaidLimit',
    MaxAmount: 'MaxAmount',
    MinAmount: 'MinAmount',
    WftUnpaidLimitBlockingOthers: 'WftUnpaidLimitBlockingOthers',
    CreditUnpaidLimitBlockingOthers: 'CreditUnpaidLimitBlockingOthers',
    CardUnpaidLimitBlockingOthers: 'CardUnpaidLimitBlockingOthers',
    CodUnpaidLimitBlockingOthers: 'CodUnpaidLimitBlockingOthers',
    CashUnpaidLimitBlockingOthers: 'CashUnpaidLimitBlockingOthers',
    EmptyUniqueId: 'EmptyUniqueId',
    MissingCustomerEmail: 'MissingCustomerEmail',
    NotAllowedRecurringForVipOrder: 'NotAllowedRecurringForVipOrder',
    MissingCustomerBirthDate: 'MissingCustomerBirthDate',
    MissingCustomerTelephone: 'MissingCustomerTelephone',
    TelephoneNumberIsNotValid: 'TelephoneNumberIsNotValid',
    OneStepProviderNotAllowedForOob: 'OneStepProviderNotAllowedForOob',
    ZeroDebt: 'ZeroDebt',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingPaymentMethodDtoPaymentMethod = {
    BlockedInvoice: 'B',
    CashOnDelivery: 'C',
    Invoice: 'I',
    CashPayment: 'M',
    NoPayment: 'N',
    Online: 'O',
    WaitingForTransfer: 'W',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderTrackingsDtoCurrentStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderTrackingStepDtoStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderStatusDtoStatus = {
    Unknown: 'Unknown',
    Blocked: 'Blocked',
    Canceled: 'Canceled',
    CancelRequested: 'CancelRequested',
    CreditNote: 'CreditNote',
    Paid: 'Paid',
    PaidPartially: 'PaidPartially',
    Pending: 'Pending',
    Unpaid: 'Unpaid',
    Waiting: 'Waiting',
    WaitingForApproval: 'WaitingForApproval',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderItemDtoReplacementType = {
    Automatic: 'A',
    Manual: 'M',
    Alternative: 'O',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderItemDtoOrderItemType = {
    Product: 'Product',
    Reservation: 'Reservation',
    Offer: 'Offer',
    Bundle: 'Bundle',
    MerchandisingDiscount: 'MerchandisingDiscount',
    MerchandisingChange: 'MerchandisingChange',
    MerchandisingGift: 'MerchandisingGift',
    MerchandisingChangedGift: 'MerchandisingChangedGift',
    Service: 'Service',
    NextOrderDelivery: 'NextOrderDelivery',
    Subscription: 'Subscription',
    BackOrder: 'BackOrder',
    EndConsumerOrder: 'EndConsumerOrder',
    Replacement: 'Replacement',
    Target: 'Target',
    FreeSample: 'FreeSample',
    Section1: 'Section1',
    Section2: 'Section2',
    Section3: 'Section3',
    Section4: 'Section4',
    Donation: 'Donation',
    Fee: 'Fee',
    PaymentFee: 'PaymentFee',
    RegistrationFee: 'RegistrationFee',
    Voucher: 'Voucher',
    StarterKit: 'StarterKit',
    RenewalFee: 'RenewalFee',
    ExtraSold: 'ExtraSold',
    ExtraChange: 'ExtraChange',
    FreeShippingJoker: 'FreeShippingJoker',
    ExtraTax: 'ExtraTax',
    Unknown: 'Unknown',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderDtoOrderOrigin = {
    Online: 'Online',
    Vip: 'Vip',
    Telephone: 'Telephone',
    Email: 'Email',
    Immediate: 'Immediate',
    Automatic: 'Automatic',
    Internal: 'Internal',
    Registration: 'Registration',
    Other: 'Other',
    Pharmacy: 'Pharmacy',
    Pbs: 'Pbs',
    WeChat: 'WeChat',
    WeChatApp: 'WeChatApp',
    NowApp: 'NowApp',
    Bambuser: 'Bambuser',
    VendingMachine: 'VendingMachine',
    Demo: 'Demo',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderDtoCurrentOrderStatus = {
    Unknown: 'Unknown',
    Blocked: 'Blocked',
    Canceled: 'Canceled',
    CancelRequested: 'CancelRequested',
    CreditNote: 'CreditNote',
    Paid: 'Paid',
    PaidPartially: 'PaidPartially',
    Pending: 'Pending',
    Unpaid: 'Unpaid',
    Waiting: 'Waiting',
    WaitingForApproval: 'WaitingForApproval',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderDtoCurrentTrackingStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOrderCancelDtoStatus = {
    Allowed: 'Allowed',
    PeriodClosingMinutesOffset: 'PeriodClosingMinutesOffset',
    PlaceOrderMinutesOffset: 'PlaceOrderMinutesOffset',
    AlreadyCancelled: 'AlreadyCancelled',
    PendingOnlinePayment: 'PendingOnlinePayment',
    IsFromOrisales: 'IsFromOrisales',
    IsPrinted: 'IsPrinted',
    IsNotCurrentPeriodOrder: 'IsNotCurrentPeriodOrder',
    IsPaidOnline: 'IsPaidOnline',
    IsOrderOriginPharmacy: 'IsOrderOriginPharmacy',
    IsNotAllowedPeriodOrder: 'IsNotAllowedPeriodOrder',
    CancellationNotAllowedByOrisales: 'CancellationNotAllowedByOrisales',
    RedeemedGiftCard: 'RedeemedGiftCard',
    FinalizedNotSynchronized: 'FinalizedNotSynchronized',
    AlreadyRequested: 'AlreadyRequested',
    CancellationNotAllowedByOrderFlow: 'CancellationNotAllowedByOrderFlow',
    CancellationOfOrdersWithGiftCardsIsDisabled: 'CancellationOfOrdersWithGiftCardsIsDisabled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOfferDtoLayout = {
    Automatic: 'Automatic',
    NoSelection: 'NoSelection',
    LimitedSelection: 'LimitedSelection',
    MediumSelection: 'MediumSelection',
    BigSelection: 'BigSelection',
    CombineSelection: 'CombineSelection',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingOfferDtoType = {
    Single: 'Single',
    SingleSelection: 'SingleSelection',
    MultipleSelection: 'MultipleSelection',
    QuantitySelection: 'QuantitySelection',
    Group: 'Group',
    LoyaltyProgram: 'LoyaltyProgram',
    WebOffer: 'WebOffer',
    ShippingOffer: 'ShippingOffer',
    CombineSelection: 'CombineSelection',
    CampaignOffer: 'CampaignOffer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingEndConsumerOrderDtoStatus = {
    Pending: 'Pending',
    Added: 'Added',
    Ordered: 'Ordered',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingDiscountDtoType = {
    None: 'None',
    Discounted: 'Discounted',
    Discount10: 'Discount10',
    Discount20: 'Discount20',
    Discount30: 'Discount30',
    Discount40: 'Discount40',
    Discount50: 'Discount50',
    Discount60: 'Discount60',
    Discount70: 'Discount70',
    Discount80: 'Discount80',
    Discount90: 'Discount90',
    Free: 'Free',
    General: 'General',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingDeliveryOptionDtoDeliveryMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingDeliveryMethodDtoType = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingDeliveryFilterDtoFilter = {
    History: 'History',
    MyHistoryAddresses: 'MyHistoryAddresses',
    MyHistoryFriends: 'MyHistoryFriends',
    PickUp: 'PickUp',
    MySpo: 'MySpo',
    PremiumSpo: 'PremiumSpo',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
    AllAddresses: 'AllAddresses',
    MyAddresses: 'MyAddresses',
    MyFriends: 'MyFriends',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingDeliveryChannelDtoDeliveryMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalShoppingBasketOfferDtoType = {
    None: 'None',
    Buy: 'Buy',
    Get: 'Get',
    Choose: 'Choose',
    ChooseAndGet: 'ChooseAndGet',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalSharedRequestValidationDtoServiceType = {
    EnterpriseV3: 'EnterpriseV3',
    ChallengeV2: 'ChallengeV2',
    HCaptcha: 'HCaptcha',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalSharedOrderDiscountDtoType = {
    Direct: 'Direct',
    Staggered: 'Staggered',
    Voucher: 'Voucher',
    PromoCode: 'PromoCode',
    Employee: 'Employee',
    Merchandising: 'Merchandising',
    Extra: 'Extra',
    GiftCard: 'GiftCard',
    Invitation: 'Invitation',
    Immediate: 'Immediate',
    Welcome: 'Welcome',
    ProductVoucher: 'ProductVoucher',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalSharedLinkDtoType = {
    Product: 'Product',
    Brand: 'Brand',
    PLpage: 'PLpage',
    EditorialArticle: 'EditorialArticle',
    Custom: 'Custom',
    Category: 'Category',
    NewProducts: 'NewProducts',
    Invite: 'Invite',
    Catalogue: 'Catalogue',
    Campaign: 'Campaign',
    NovageSkincareAdvisor: 'NovageSkincareAdvisor',
    EditorialCampaign: 'EditorialCampaign',
    Ingredient: 'Ingredient',
    SignIn: 'SignIn',
    Frontpage: 'Frontpage',
    RegistrationPage: 'RegistrationPage',
    InvitationOffer: 'InvitationOffer',
    Brands: 'Brands',
    FoundationFinder: 'FoundationFinder',
    VirtualTryOn: 'VirtualTryOn',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalSharedAddressDtoAddressType = {
    Home: 'Home',
    Channel: 'Channel',
    Delivery: 'Delivery',
    Other: 'Other',
    Kyc: 'Kyc',
    Subscription: 'Subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalRequestValidationMetadataRequestValidationMetadataDtoServiceType = {
    EnterpriseV3: 'EnterpriseV3',
    ChallengeV2: 'ChallengeV2',
    HCaptcha: 'HCaptcha',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPromotionsPromotionDtoType = {
    Unknown: 'Unknown',
    PromoCode: 'PromoCode',
    CustomerPromoCode: 'CustomerPromoCode',
    RecommendAFriend: 'RecommendAFriend',
    FreeShipping: 'FreeShipping',
    PercentageDiscount: 'PercentageDiscount',
    FixedDiscount: 'FixedDiscount',
    Mgm: 'Mgm',
    Referral: 'Referral',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsReplacementDtoReplacementType = {
    Automatic: 'Automatic',
    Manual: 'Manual',
    Subscription: 'Subscription',
    Alternative: 'Alternative',
    WellnessAutomatic: 'WellnessAutomatic',
    WellnessManual: 'WellnessManual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsRelationRelationType = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
    Popular: 'Popular',
    Favourite: 'Favourite',
    Samples: 'Samples',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsProductListingItemDtoType = {
    Product: 'Product',
    PromoBanner: 'PromoBanner',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsProductLabelsDtoProductLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsProductLabelsDtoProductsLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsProductDtoProductType = {
    Product: 'Product',
    Bundle: 'Bundle',
    Sample: 'Sample',
    Fee: 'Fee',
    Composite: 'Composite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalProductsBannerVideoDtoType = {
    None: 'None',
    Mp4: 'Mp4',
    Youtube: 'Youtube',
    Youku: 'Youku',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPersonalBeautyStoreConfigurationConfigurationDtoBeautyStoreType = {
    PbsStandard: 'PbsStandard',
    PbsLite: 'PbsLite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPendingRegistrationsPendingRegistrationDtoRegistrationState = {
    Pending: 'Pending',
    Submitted: 'Submitted',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentsPaymentDtoPaymentState = {
    Error: 'Error',
    PaymentDone: 'PaymentDone',
    ReadyToProcess: 'ReadyToProcess',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentsPayUPaymentResponseDtoOperationStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    Cancelled: 'Cancelled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentsPayUPaymentResponseDtoStatus = {
    Created: 'Created',
    Pending: 'Pending',
    Authorized: 'Authorized',
    Settled: 'Settled',
    Refused: 'Refused',
    Cancelled: 'Cancelled',
    Expired: 'Expired',
    Refunded: 'Refunded',
    PreSettled: 'PreSettled',
    NotFound: 'NotFound',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentsOnlinePaymentDtoClientApp = {
    Unknown: 'Unknown',
    Online: 'Online',
    OriflameApp: 'OriflameApp',
    BusinessApp: 'BusinessApp',
    WeChat: 'WeChat',
    SuperApp: 'SuperApp',
    Mv7App: 'Mv7App',
    Orisales: 'Orisales',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentsOnlinePaymentDtoStatus = {
    Created: 'Created',
    Pending: 'Pending',
    Authorized: 'Authorized',
    Settled: 'Settled',
    Refused: 'Refused',
    Cancelled: 'Cancelled',
    Expired: 'Expired',
    Refunded: 'Refunded',
    PreSettled: 'PreSettled',
    NotFound: 'NotFound',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentProvidersPaymentProviderDtoBlockReason = {
    Terminated: 'Terminated',
    OverdueOrders: 'OverdueOrders',
    CantOrder: 'CantOrder',
    PendingLimit: 'PendingLimit',
    CreditLimit: 'CreditLimit',
    UnpaidInterest: 'UnpaidInterest',
    CantOrderOnCredit: 'CantOrderOnCredit',
    CodUnpaidLimit: 'CodUnpaidLimit',
    WftUnpaidLimit: 'WftUnpaidLimit',
    CardUnpaidLimit: 'CardUnpaidLimit',
    CrossBranch: 'CrossBranch',
    CreditUnpaidLimit: 'CreditUnpaidLimit',
    CashUnpaidLimit: 'CashUnpaidLimit',
    VipTotalUnpaidLimit: 'VipTotalUnpaidLimit',
    CustomerTotalUnpaidLimit: 'CustomerTotalUnpaidLimit',
    MaxAmount: 'MaxAmount',
    MinAmount: 'MinAmount',
    WftUnpaidLimitBlockingOthers: 'WftUnpaidLimitBlockingOthers',
    CreditUnpaidLimitBlockingOthers: 'CreditUnpaidLimitBlockingOthers',
    CardUnpaidLimitBlockingOthers: 'CardUnpaidLimitBlockingOthers',
    CodUnpaidLimitBlockingOthers: 'CodUnpaidLimitBlockingOthers',
    CashUnpaidLimitBlockingOthers: 'CashUnpaidLimitBlockingOthers',
    EmptyUniqueId: 'EmptyUniqueId',
    MissingCustomerEmail: 'MissingCustomerEmail',
    NotAllowedRecurringForVipOrder: 'NotAllowedRecurringForVipOrder',
    MissingCustomerBirthDate: 'MissingCustomerBirthDate',
    MissingCustomerTelephone: 'MissingCustomerTelephone',
    TelephoneNumberIsNotValid: 'TelephoneNumberIsNotValid',
    OneStepProviderNotAllowedForOob: 'OneStepProviderNotAllowedForOob',
    ZeroDebt: 'ZeroDebt',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentMethodsPaymentMethodDtoBlockReason = {
    Terminated: 'Terminated',
    OverdueOrders: 'OverdueOrders',
    CantOrder: 'CantOrder',
    PendingLimit: 'PendingLimit',
    CreditLimit: 'CreditLimit',
    UnpaidInterest: 'UnpaidInterest',
    CantOrderOnCredit: 'CantOrderOnCredit',
    CodUnpaidLimit: 'CodUnpaidLimit',
    WftUnpaidLimit: 'WftUnpaidLimit',
    CardUnpaidLimit: 'CardUnpaidLimit',
    CrossBranch: 'CrossBranch',
    CreditUnpaidLimit: 'CreditUnpaidLimit',
    CashUnpaidLimit: 'CashUnpaidLimit',
    VipTotalUnpaidLimit: 'VipTotalUnpaidLimit',
    CustomerTotalUnpaidLimit: 'CustomerTotalUnpaidLimit',
    MaxAmount: 'MaxAmount',
    MinAmount: 'MinAmount',
    WftUnpaidLimitBlockingOthers: 'WftUnpaidLimitBlockingOthers',
    CreditUnpaidLimitBlockingOthers: 'CreditUnpaidLimitBlockingOthers',
    CardUnpaidLimitBlockingOthers: 'CardUnpaidLimitBlockingOthers',
    CodUnpaidLimitBlockingOthers: 'CodUnpaidLimitBlockingOthers',
    CashUnpaidLimitBlockingOthers: 'CashUnpaidLimitBlockingOthers',
    EmptyUniqueId: 'EmptyUniqueId',
    MissingCustomerEmail: 'MissingCustomerEmail',
    NotAllowedRecurringForVipOrder: 'NotAllowedRecurringForVipOrder',
    MissingCustomerBirthDate: 'MissingCustomerBirthDate',
    MissingCustomerTelephone: 'MissingCustomerTelephone',
    TelephoneNumberIsNotValid: 'TelephoneNumberIsNotValid',
    OneStepProviderNotAllowedForOob: 'OneStepProviderNotAllowedForOob',
    ZeroDebt: 'ZeroDebt',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalPaymentMethodsPaymentMethodDtoPaymentMethodType = {
    BlockedInvoice: 'B',
    CashOnDelivery: 'C',
    Invoice: 'I',
    CashPayment: 'M',
    NoPayment: 'N',
    Online: 'O',
    WaitingForTransfer: 'W',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalParentalConsentRegistrationParentalConsentMetadataDtoParentalConsentMode = {
    ParentalInfo: 'ParentalInfo',
    InfoMessage: 'InfoMessage',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalParentalConsentParentalConsentDtoConsentType = {
    SimplifiedBrandPartner: 'SimplifiedBrandPartner',
    SimplifiedVip: 'SimplifiedVip',
    SimplifiedCheckout: 'SimplifiedCheckout',
    SponsorRegistrationBrandPartner: 'SponsorRegistrationBrandPartner',
    SponsorRegistrationVip: 'SponsorRegistrationVip',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalOrdersOrderDocumentDtoDocumentType = {
    InvoicePdf: 'InvoicePdf',
    InvoiceXml: 'InvoiceXml',
    FiscalReceipt: 'FiscalReceipt',
    ReturnFiscalReceipt: 'ReturnFiscalReceipt',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalOnboardingOnboardingDtoCurrentStep = {
    PersonalDetails: 'PersonalDetails',
    ELearning: 'ELearning',
    LegalDocument: 'LegalDocument',
    Completed: 'Completed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsPushRegistrationDtoPlatform = {
    Apple: 'Apple',
    Baidu: 'Baidu',
    Gcm: 'Gcm',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsMobileTemplateDtoClientApplicationId = {
    CnSuperApp: 'CnSuperApp',
    OriflameApp: 'OriflameApp',
    SkinExpert: 'SkinExpert',
    BusinessApp: 'BusinessApp',
    MakeupWizard: 'MakeupWizard',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsMobileNotificationDtoClientApplication = {
    CnSuperApp: 'CnSuperApp',
    OriflameApp: 'OriflameApp',
    SkinExpert: 'SkinExpert',
    BusinessApp: 'BusinessApp',
    MakeupWizard: 'MakeupWizard',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsInstallationRequestDtoPlatform = {
    Adm: 'Adm',
    Apple: 'Apple',
    Baidu: 'Baidu',
    Gcm: 'Gcm',
    Mpns: 'Mpns',
    Windows: 'Windows',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsCustomerNotificationSearchResultItemDtoTarget = {
    ConsultantNumbers: 'ConsultantNumbers',
    Sponsor: 'Sponsor',
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsCustomerNotificationSearchRequestDtoStatus = {
    Draft: 'Draft',
    Sent: 'Sent',
    Sending: 'Sending',
    Delivering: 'Delivering',
    Delivered: 'Delivered',
    NoRecipients: 'NoRecipients',
    SendingFailed: 'SendingFailed',
    PartiallyDelivered: 'PartiallyDelivered',
    DeliveryFailed: 'DeliveryFailed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsCustomerNotificationDtoStatus = {
    Draft: 'Draft',
    Sent: 'Sent',
    Sending: 'Sending',
    Delivering: 'Delivering',
    Delivered: 'Delivered',
    NoRecipients: 'NoRecipients',
    SendingFailed: 'SendingFailed',
    PartiallyDelivered: 'PartiallyDelivered',
    DeliveryFailed: 'DeliveryFailed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsCustomerNotificationDtoTarget = {
    ConsultantNumbers: 'ConsultantNumbers',
    Sponsor: 'Sponsor',
    FirstLevel: 'FirstLevel',
    PersonalGroup: 'PersonalGroup',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsBulkMobileNotificationDtoPushClientApplicationsItem = {
    CnSuperApp: 'CnSuperApp',
    OriflameApp: 'OriflameApp',
    SkinExpert: 'SkinExpert',
    BusinessApp: 'BusinessApp',
    MakeupWizard: 'MakeupWizard',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNotificationsBulkMobileNotificationDtoClientApplicationsItem = {
    CnSuperApp: 'CnSuperApp',
    OriflameApp: 'OriflameApp',
    SkinExpert: 'SkinExpert',
    BusinessApp: 'BusinessApp',
    MakeupWizard: 'MakeupWizard',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNewsletterSubscriptionsNewsletterSubscriptionStatusDtoStatus = {
    Unknown: 'Unknown',
    New: 'New',
    Subscribed: 'Subscribed',
    Pending: 'Pending',
    Unsubscribed: 'Unsubscribed',
    Cleaned: 'Cleaned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNavigationNavigationItemDtoType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
    TopAreaNavigation: 'TopAreaNavigation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalNavigationNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    IconsInCategory: 'IconsInCategory',
    BestsellersInCategory: 'BestsellersInCategory',
    New: 'New',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
    Inspiration: 'Inspiration',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
    BeautyTips: 'BeautyTips',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalModularPagesPageModuleDtoType = {
    Banner: 'Banner',
    FiftyBanner: 'FiftyBanner',
    Highlights: 'Highlights',
    HowToUse: 'HowToUse',
    ProductBoxCarousel: 'ProductBoxCarousel',
    Olapic: 'Olapic',
    Header: 'Header',
    TestimonialCarousel: 'TestimonialCarousel',
    FrequentlyAskedQuestions: 'FrequentlyAskedQuestions',
    LinkList: 'LinkList',
    Benefits: 'Benefits',
    LinkCarousel: 'LinkCarousel',
    EditorialCarousel: 'EditorialCarousel',
    MixedPlpContent: 'MixedPlpContent',
    EditorialBannerCarousel: 'EditorialBannerCarousel',
    Table: 'Table',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalModularLandingPagesLandingPageDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalModularLandingPagesLandingPageDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDtoTaskStatus = {
    IsCompleted: 'IsCompleted',
    IsActive: 'IsActive',
    Inactive: 'Inactive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalLoginProvidersWeChatPlatformDtoType = {
    WeChatMini: 'WeChatMini',
    SuperApp: 'SuperApp',
    Elearning: 'Elearning',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalLmdScheduleDayDeliveryChannelDtoDayOfWeek = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalEnumsBackgroundColorDtoType = {
    White: 'White',
    Brown: 'Brown',
    Green: 'Green',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalEndConsumerOrdersEndConsumerOrderDtoEndConsumerOrderStatus = {
    Pending: 'Pending',
    Added: 'Added',
    Ordered: 'Ordered',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalEndConsumerOrdersEndConsumerOrderDtoEndConsumerOrderType = {
    BeautyStore: 'BeautyStore',
    IntegratedBeautyStore: 'IntegratedBeautyStore',
    ECatalogue: 'ECatalogue',
    MobileOrderPad: 'MobileOrderPad',
    Online: 'Online',
    MobileMakeupWizard: 'MobileMakeupWizard',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalEditorialArticlesEditorialArticleDtoArticleType = {
    Undefined: 'Undefined',
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalDigitalPromotionsCurrentPromotionDtoChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalDigitalPromotionsCurrentPromotionDtoPromotionType = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalDeliveryDeliveryChannelDtoDeliveryMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersWalletWalletTransactionTransactionType = {
    Pending: 'Pending',
    Received: 'Received',
    Used: 'Used',
    Returned: 'Returned',
    Refund: 'Refund',
    Expired: 'Expired',
    Unknown: 'Unknown',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersWalletWalletTransactionDiscountType = {
    Cashback: 'Cashback',
    SharingDiscount: 'SharingDiscount',
    OriflameWallet: 'OriflameWallet',
    Other: 'Other',
    ManualAdjustment: 'ManualAdjustment',
    ReferralDiscount: 'ReferralDiscount',
    Unknown: 'Unknown',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersTelephoneVerificationRequestDtoRequestStatus = {
    NotExists: 'NotExists',
    Pending: 'Pending',
    Confirmed: 'Confirmed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersTaxClassificationDtoTaxClassificationType = {
    PhysicalPerson: 'PhysicalPerson',
    VatPayer: 'VatPayer',
    Entrepreneur: 'Entrepreneur',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSubscriptionTypeDtoCategory = {
    Wellness: 'Wellness',
    LifePlus: 'LifePlus',
    HairCare: 'HairCare',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSubscriptionInstructionDtoStatus = {
    Pending: 'Pending',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSubscriptionDtoStatus = {
    Created: 'Created',
    Renewed: 'Renewed',
    Closed: 'Closed',
    Canceled: 'Canceled',
    Autocanceled: 'Autocanceled',
    Reactivated: 'Reactivated',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSponsorDtoSponsorType = {
    DirectSponsor: 'DirectSponsor',
    Unknown: 'Unknown',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSponsorChangeInviteDtoStatus = {
    Initiated: 'Initiated',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSocialContactDtoType = {
    Email: 'Email',
    PhoneNumber: 'PhoneNumber',
    WhatsUpNumber: 'WhatsUpNumber',
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    WeChat: 'WeChat',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSelfRegistrationDtoConsultantType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
    DirectSeller: 'DirectSeller',
    SpoOwner: 'SpoOwner',
    Agent: 'Agent',
    Corporate: 'Corporate',
    LegacyConsultant: 'LegacyConsultant',
    LegacyManager: 'LegacyManager',
    FamilyContractor: 'FamilyContractor',
    LegacyDirector: 'LegacyDirector',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSelfRegistrationDtoActivationType = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersSelfRegistrationDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersRequiredTermDtoType = {
    TermsAndConditions: 'TermsAndConditions',
    PrivacyPolicy: 'PrivacyPolicy',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersRegistrationStatusDtoOnBehalfNotificationAction = {
    None: 'None',
    NotSent: 'NotSent',
    RegistrationSent: 'RegistrationSent',
    RegistrationWithOrderSent: 'RegistrationWithOrderSent',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersRegistrationStatusDtoRegistrationState = {
    Finished: 'Finished',
    Pending: 'Pending',
    OnBehalfPending: 'OnBehalfPending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersRegistrationOrderDtoProcessState = {
    Created: 'Created',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersRegistrationInfoDtoRegistrationSource = {
    None: 'None',
    SelfRegistrationConsultant: 'SelfRegistrationConsultant',
    SelfRegistrationVip: 'SelfRegistrationVip',
    CheckoutEcRegistration: 'CheckoutEcRegistration',
    CheckoutConsultantRegistration: 'CheckoutConsultantRegistration',
    SponsorRegistrationConsultant: 'SponsorRegistrationConsultant',
    SponsorRegistrationVip: 'SponsorRegistrationVip',
    OnBehalfRegistration: 'OnBehalfRegistration',
    SocialNetworks: 'SocialNetworks',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersReferralProgramDtoAllowedContactsItem = {
    Email: 'Email',
    PhoneNumber: 'PhoneNumber',
    WhatsUpNumber: 'WhatsUpNumber',
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    WeChat: 'WeChat',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersProfileFieldDtoProfileField = {
    FirstName: 'FirstName',
    LastName: 'LastName',
    Gender: 'Gender',
    PreferredLanguage: 'PreferredLanguage',
    BirthDate: 'BirthDate',
    UniqueId: 'UniqueId',
    DisplayName: 'DisplayName',
    Alias: 'Alias',
    TaxCode: 'TaxCode',
    TaxCode2: 'TaxCode2',
    PassportNumber: 'PassportNumber',
    Pin: 'Pin',
    RecurringPaymentCards: 'RecurringPaymentCards',
    Branch: 'Branch',
    Email: 'Email',
    MyWhy: 'MyWhy',
    Interests: 'Interests',
    Address: 'Address',
    Telephone: 'Telephone',
    BankAccount: 'BankAccount',
    ProfileImage: 'ProfileImage',
    EWallet: 'EWallet',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersProfileDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersPhoneDtoTelephoneType = {
    Home: 'Home',
    Business: 'Business',
    Mobile: 'Mobile',
    Fax: 'Fax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersPersonalSubscriptionDtoPauseReason = {
    None: 'None',
    TerminatedCustomer: 'TerminatedCustomer',
    CustomerCanNotOrder: 'CustomerCanNotOrder',
    ProductOutOfStock: 'ProductOutOfStock',
    ProductNotFound: 'ProductNotFound',
    ProductPriceNotFound: 'ProductPriceNotFound',
    InvalidDelivery: 'InvalidDelivery',
    InvalidDeliveryAddress: 'InvalidDeliveryAddress',
    InvalidPayment: 'InvalidPayment',
    OrderFailed: 'OrderFailed',
    ExpiredRecurringCard: 'ExpiredRecurringCard',
    MissingRecurringCard: 'MissingRecurringCard',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersPersonalSubscriptionDtoCategory = {
    Product: 'Product',
    PersonalNutrition: 'PersonalNutrition',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersOnBehalfFeedbackCreateDtoReason = {
    OrderSpam: 'OrderSpam',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersMetadataAddressSearchMetadataDtoAllowedSearchResultsItem = {
    Market: 'Market',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    Street: 'Street',
    ZipCode: 'ZipCode',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersInternationalInfoForeignCountryDtoOrigin = {
    RegistrationForm: 'RegistrationForm',
    Termination: 'Termination',
    ShareAndEarn: 'ShareAndEarn',
    HomeCountryChange: 'HomeCountryChange',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersInternationalInfoForeignCountryDtoStatus = {
    Active: 'Active',
    Terminated: 'Terminated',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersGrantedCreditDtoGrantedCreditAuthorization = {
    Guaranteed: 'Guaranteed',
    None: 'None',
    Predeterminated: 'Predeterminated',
    Exclusive: 'Exclusive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEndCustomerDtoEndCustomerType = {
    Standard: 'Standard',
    Anonymous: 'Anonymous',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEndCustomerDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEndConsumerDtoEndConsumerType = {
    Standard: 'Standard',
    External: 'External',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEmailVerificationRequestDtoRequestStatus = {
    NotExists: 'NotExists',
    Pending: 'Pending',
    Confirmed: 'Confirmed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEditorialsLandingPageDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEditorialsLandingPageDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEditorialsLandingPageDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEditorialsContentDtoType = {
    Header: 'Header',
    Banner: 'Banner',
    Olapic: 'Olapic',
    ProductBoxCarousel: 'ProductBoxCarousel',
    EditorialCarousel: 'EditorialCarousel',
    MixedPlpContent: 'MixedPlpContent',
    EditorialBannerCarousel: 'EditorialBannerCarousel',
    TestimonialCarousel: 'TestimonialCarousel',
    FrequentlyAskedQuestions: 'FrequentlyAskedQuestions',
    LinkList: 'LinkList',
    FiftyBanner: 'FiftyBanner',
    Benefits: 'Benefits',
    LinkCarousel: 'LinkCarousel',
    Table: 'Table',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersEWalletAccountDtoType = {
    Revolut: 'Revolut',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersDocumentTypeDtoDocumentCategory = {
    General: 'General',
    CreditRequest: 'CreditRequest',
    Personal: 'Personal',
    Claim: 'Claim',
    Legal: 'Legal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersDocumentTypeDtoDocumentTag = {
    NotSpecified: 'NotSpecified',
    IdentityCard: 'IdentityCard',
    Passport: 'Passport',
    ProfileImage: 'ProfileImage',
    DamageParcel: 'DamageParcel',
    DamageCover: 'DamageCover',
    BankAccount: 'BankAccount',
    WellnessSellingApplication: 'WellnessSellingApplication',
    WellnessSellingCertificate: 'WellnessSellingCertificate',
    Caf: 'Caf',
    Commitment: 'Commitment',
    Annex: 'Annex',
    DamagedProduct: 'DamagedProduct',
    ExportedFile: 'ExportedFile',
    Custom: 'Custom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersDocumentApprovalDtoApprovalState = {
    Pending: 'Pending',
    Rejected: 'Rejected',
    Approved: 'Approved',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCustomerTypeDtoCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCustomerProfileCompletenessDtoCompletenessLevel = {
    Low: 'Low',
    Medium: 'Medium',
    Strong: 'Strong',
    Completed: 'Completed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCustomerPreferencesDtoInterestsItem = {
    NovAge: 'NovAge',
    Wellness: 'Wellness',
    Business: 'Business',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCustomerInfoDtoActivationChannel = {
    Email: 'Email',
    Sms: 'Sms',
    WhatsApp: 'WhatsApp',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCustomerInfoDtoVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersCounterpartyEWalletAccountDtoType = {
    Revolut: 'Revolut',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersConsultantRegistrationDtoRegistrationType = {
    Sponsor: 'Sponsor',
    SpoSponsor: 'SpoSponsor',
    CustomerService: 'CustomerService',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersConsultantRegistrationDtoConsultantType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
    DirectSeller: 'DirectSeller',
    SpoOwner: 'SpoOwner',
    Agent: 'Agent',
    Corporate: 'Corporate',
    LegacyConsultant: 'LegacyConsultant',
    LegacyManager: 'LegacyManager',
    FamilyContractor: 'FamilyContractor',
    LegacyDirector: 'LegacyDirector',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersConsultantRegistrationDtoActivationType = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersConsultantRegistrationDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersConfirmationDtoConfirmationType = {
    Telephone: 'Telephone',
    Email: 'Email',
    Activation: 'Activation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersBonusBlockingReasonBlockingType = {
    Undefined: 'Undefined',
    MissingBankInformation: 'MissingBankInformation',
    CustomInfo: 'CustomInfo',
    OverdueDebt: 'OverdueDebt',
    ManualBlock: 'ManualBlock',
    BonusBelowMinimumAmountToRelease: 'BonusBelowMinimumAmountToRelease',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersBlockingDtoBlockingState = {
    Valid: 'Valid',
    Expired: 'Expired',
    Future: 'Future',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersBankBonusPaymentSummaryReportDtoState = {
    Undefined: 'Undefined',
    NothingForTransfer: 'NothingForTransfer',
    Pending: 'Pending',
    Transferred: 'Transferred',
    Blocked: 'Blocked',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersBankAccountDtoBankAccountType = {
    Primary: 'Primary',
    DirectDebit: 'DirectDebit',
    Tax: 'Tax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersBankAccountApprovalDtoApprovalState = {
    Rejected: 'Rejected',
    Approved: 'Approved',
    Pending: 'Pending',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAutoshipTypeDtoCategory = {
    Wellness: 'Wellness',
    LifePlus: 'LifePlus',
    HairCare: 'HairCare',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAutoshipInstructionDtoStatus = {
    Pending: 'Pending',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAnonymousConfirmationDtoConfirmationType = {
    Email: 'Email',
    Activation: 'Activation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAdyenContractDisableRequestDtoContractItem = {
    ONECLICK: 'ONECLICK',
    RECURRING: 'RECURRING',
    PAYOUT: 'PAYOUT',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAddressFormatLineDtoFieldsItem = {
    AddressType: 'AddressType',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    StreetAddress: 'StreetAddress',
    ZipCode: 'ZipCode',
    Delivery: 'Delivery',
    CustomerName: 'CustomerName',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAddressFormatDtoType = {
    SingleLine: 'SingleLine',
    MultiLine: 'MultiLine',
    CustomerMultiLine: 'CustomerMultiLine',
    Searched: 'Searched',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersAddressDtoAddressType = {
    Home: 'Home',
    Channel: 'Channel',
    Delivery: 'Delivery',
    Other: 'Other',
    Kyc: 'Kyc',
    Subscription: 'Subscription',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersActivationRequestMetadataDtoActivationChannelType = {
    None: 'None',
    Email: 'Email',
    Telephone: 'Telephone',
    All: 'All',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomersActivationRequestDtoRequestStatus = {
    Pending: 'Pending',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRelationshipsCustomerRelationshipForInsertDtoRelationshipType = {
    FavoriteContact: 'FavoriteContact',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRelationshipsCustomerRelationshipDtoRelationshipType = {
    FavoriteContact: 'FavoriteContact',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationStepDtoCurrentStep = {
    Prestep: 'Prestep',
    ContactVerification: 'ContactVerification',
    PersonalInfoStep: 'PersonalInfoStep',
    SponsorSelectionStep: 'SponsorSelectionStep',
    LegalInformationStep: 'LegalInformationStep',
    SubmitStep: 'SubmitStep',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationSponsorDetailsDtoSponsorOrigin = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
    Pbs: 'Pbs',
    ReferralLink: 'ReferralLink',
    InternationalPbs: 'InternationalPbs',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationPersonalDetailsDtoGender = {
    Man: 'Man',
    Woman: 'Woman',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationDtoSponsorOrigin = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
    Pbs: 'Pbs',
    ReferralLink: 'ReferralLink',
    InternationalPbs: 'InternationalPbs',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationDtoLoginType = {
    Email: 'Email',
    Telephone: 'Telephone',
    Facebook: 'Facebook',
    Apple: 'Apple',
    Google: 'Google',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationDtoCurrentStep = {
    Prestep: 'Prestep',
    ContactVerification: 'ContactVerification',
    PersonalInfoStep: 'PersonalInfoStep',
    SponsorSelectionStep: 'SponsorSelectionStep',
    LegalInformationStep: 'LegalInformationStep',
    SubmitStep: 'SubmitStep',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationsRegistrationDtoRegistrationType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsOnBehalfRegistrationStatusDtoRegistrationStatus = {
    Initiated: 'Initiated',
    Submitted: 'Submitted',
    Accepted: 'Accepted',
    Terminated: 'Terminated',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsLegalDetailsMetadataDtoTermsCustomerType = {
    Consultant: 'Consultant',
    EndCustomer: 'EndCustomer',
    VipCustomer: 'VipCustomer',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsCustomerRegistrationInstructionDtoRegistrationState = {
    Pending: 'Pending',
    Submitted: 'Submitted',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsCustomerRegistrationInstructionDtoRegistrationType = {
    SelfBrandPartner: 'SelfBrandPartner',
    SelfVip: 'SelfVip',
    SponsorBrandPartner: 'SponsorBrandPartner',
    SponsorVip: 'SponsorVip',
    Checkout: 'Checkout',
    SponsorOnBehalf: 'SponsorOnBehalf',
    SelfOnBehalf: 'SelfOnBehalf',
    SocialNetworks: 'SocialNetworks',
    SelfOnBehalfVip: 'SelfOnBehalfVip',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsCustomerRegistrationInstructionCreateDtoRegistrationType = {
    SelfBrandPartner: 'SelfBrandPartner',
    SelfVip: 'SelfVip',
    SponsorBrandPartner: 'SponsorBrandPartner',
    SponsorVip: 'SponsorVip',
    Checkout: 'Checkout',
    SponsorOnBehalf: 'SponsorOnBehalf',
    SelfOnBehalf: 'SelfOnBehalf',
    SocialNetworks: 'SocialNetworks',
    SelfOnBehalfVip: 'SelfOnBehalfVip',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerRegistrationInstructionsContactDetailsDtoDefaultNotificationChannel = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCustomerFeedbackReviewDtoReviewState = {
    AwaitingApproval: 'AwaitingApproval',
    Published: 'Published',
    Rejected: 'Rejected',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConsultantsSettingDtoFormat = {
    Json: 'Json',
    Xml: 'Xml',
    String: 'String',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConsultantsBusinessToolSettingDtoFormat = {
    Json: 'Json',
    Xml: 'Xml',
    String: 'String',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConsultantsBusinessToolSettingDtoPrepaymentProgram = {
    Free: 'Free',
    PaidUsage: 'PaidUsage',
    PaidActivation: 'PaidActivation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConsultantsBusinessToolActivationDtoFormat = {
    Json: 'Json',
    Xml: 'Xml',
    String: 'String',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConceptsConceptLabelsDtoConceptLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalConceptsConceptLabelsDtoConceptLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCommissionPlansCustomerWithBasicInfoDtoTitleCode = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCommissionPlansAdvancedBonusQualificationDtoBonusType = {
    Director: 'Director',
    Gold: 'Gold',
    Sapphire: 'Sapphire',
    Diamond: 'Diamond',
    DoubleDiamond: 'DoubleDiamond',
    Executive: 'Executive',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimsClaimDtoStatus = {
    Created: 'Created',
    Saved: 'Saved',
    PartiallyApproved: 'PartiallyApproved',
    Approved: 'Approved',
    Denied: 'Denied',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimsClaimDtoType = {
    ReturnExchangeOrMissingProduct: 'ReturnExchangeOrMissingProduct',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimsClaimApprovalDtoStatus = {
    Created: 'Created',
    Saved: 'Saved',
    PartiallyApproved: 'PartiallyApproved',
    Approved: 'Approved',
    Denied: 'Denied',
    Finished: 'Finished',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsReturnedClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsReturnClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsMissingClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsMissedClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsExchangedClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsExchangeClaimItemDtoReason = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsClaimingDtoClaimType = {
    ReturnExchangeOrMissingProduct: 'ReturnExchangeOrMissingProduct',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsClaimSessionDtoClaimType = {
    ReturnExchangeOrMissingProduct: 'ReturnExchangeOrMissingProduct',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsClaimDeliveryMethodDtoType = {
    PickupPoint: 'PickupPoint',
    Home: 'Home',
    Spo: 'Spo',
    Lpo: 'Lpo',
    PostOffice: 'PostOffice',
    DepartmentStore: 'DepartmentStore',
    NextOrder: 'NextOrder',
    ParcelLocker: 'ParcelLocker',
    NearestPostOffice: 'NearestPostOffice',
    LastUsed: 'LastUsed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimSessionsClaimDeliveryChannelDtoDeliveryMethod = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoAllowedExchangeProducts = {
    All: 'All',
    SameProductOnly: 'SameProductOnly',
    DifferentProductOnly: 'DifferentProductOnly',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoEnabledForProductCategory = {
    None: 'None',
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoBatchIdProductCategory = {
    None: 'None',
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoActionId = {
    ReturnProduct: 'ReturnProduct',
    ExchangeProduct: 'ExchangeProduct',
    CancelProduct: 'CancelProduct',
    ResendProduct: 'ResendProduct',
    CancelOrder: 'CancelOrder',
    ResendOrder: 'ResendOrder',
    None: 'None',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoCauseId = {
    AdverseReaction: 'AdverseReaction',
    UnwantedProduct: 'UnwantedProduct',
    DamagedOrDefectedProduct: 'DamagedOrDefectedProduct',
    MissingProduct: 'MissingProduct',
    WrongProductDelivered: 'WrongProductDelivered',
    ParcelNotDelivered: 'ParcelNotDelivered',
    ParcelDamaged: 'ParcelDamaged',
    ParcelRefused: 'ParcelRefused',
    InvoiceCampaignProductMissing: 'InvoiceCampaignProductMissing',
    InvoiceWrongPriceOrFee: 'InvoiceWrongPriceOrFee',
    CancelOrder: 'CancelOrder',
    RefundReturnCost: 'RefundReturnCost',
    WrongPriceFix: 'WrongPriceFix',
    SupplementaryProduct: 'SupplementaryProduct',
    ExtraProductReceivedMissingOnTheInvoice: 'ExtraProductReceivedMissingOnTheInvoice',
    ExtraProductReceivedWrongQuantity: 'ExtraProductReceivedWrongQuantity',
    UncollectedParcel: 'UncollectedParcel',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimScenarioDtoCategoryId = {
    Root: 'Root',
    ReturnExchangeMissing: 'ReturnExchangeMissing',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
    Return: 'Return',
    Exchange: 'Exchange',
    Missing: 'Missing',
    WrongProductDelivered: 'WrongProductDelivered',
    ProductJustMissing: 'ProductJustMissing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimReasonDtoReasonId = {
    DidntMeetExpectations: 'DidntMeetExpectations',
    NotUsedProductNotMeetExpectations: 'NotUsedProductNotMeetExpectations',
    UsedProductNotMeetExpectations: 'UsedProductNotMeetExpectations',
    WrongProductOrdered: 'WrongProductOrdered',
    DidntMatchTheProductDescription: 'DidntMatchTheProductDescription',
    DescriptionFoundInCatalogue: 'DescriptionFoundInCatalogue',
    DescriptionFoundOnline: 'DescriptionFoundOnline',
    DescriptionFoundInOtherCommunication: 'DescriptionFoundInOtherCommunication',
    NoReasonJustChangedMyMind: 'NoReasonJustChangedMyMind',
    NotUsedProductNoReason: 'NotUsedProductNoReason',
    UsedProductNoReason: 'UsedProductNoReason',
    PackagingQualityIssue: 'PackagingQualityIssue',
    BatchNumberOrExpiryDateMissingNotReadable: 'BatchNumberOrExpiryDateMissingNotReadable',
    PackagingDamagedByLeakageFromAnotherProduct: 'PackagingDamagedByLeakageFromAnotherProduct',
    DamagedContainerJarTubeBottlePouch: 'DamagedContainerJarTubeBottlePouch',
    DamagedPackagingExternalProductBoxTamperProofPolybagFoil: 'DamagedPackagingExternalProductBoxTamperProofPolybagFoil',
    ProductIsLeaking: 'ProductIsLeaking',
    MissingLabelOrLeaflet: 'MissingLabelOrLeaflet',
    PoorLabelling: 'PoorLabelling',
    DifferentProductThanStatedOnPackOrLabel: 'DifferentProductThanStatedOnPackOrLabel',
    ProductContentQualityIssue: 'ProductContentQualityIssue',
    DamagedOrDeformed_22: 'DamagedOrDeformed_22',
    ColorVariation: 'ColorVariation',
    SmellChangedOrUnpleasant: 'SmellChangedOrUnpleasant',
    TasteChangedOrUnpleasant: 'TasteChangedOrUnpleasant',
    ConsistencyOrTextureVariation: 'ConsistencyOrTextureVariation',
    ContaminatedByForeignObject: 'ContaminatedByForeignObject',
    ContentDamagedByLeakageFromAnotherProduct: 'ContentDamagedByLeakageFromAnotherProduct',
    MissingPart: 'MissingPart',
    WrongQuantity: 'WrongQuantity',
    MechanismProblems: 'MechanismProblems',
    WorkingPoorly: 'WorkingPoorly',
    NotWorkingAtAll: 'NotWorkingAtAll',
    ParcelDelayed: 'ParcelDelayed',
    WrongAddress: 'WrongAddress',
    ParcelIsLost: 'ParcelIsLost',
    NotUsedProduct: 'NotUsedProduct',
    UsedProduct: 'UsedProduct',
    DamagedByAnotherProduct: 'DamagedByAnotherProduct',
    Leakage: 'Leakage',
    DamagedOrDeformed: 'DamagedOrDeformed',
    ForeignMatter: 'ForeignMatter',
    ConsistencyColorOrScentIssue: 'ConsistencyColorOrScentIssue',
    Malfunction: 'Malfunction',
    MissingPartsOrUnderfilled: 'MissingPartsOrUnderfilled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimCauseDtoCauseId = {
    AdverseReaction: 'AdverseReaction',
    UnwantedProduct: 'UnwantedProduct',
    DamagedOrDefectedProduct: 'DamagedOrDefectedProduct',
    MissingProduct: 'MissingProduct',
    WrongProductDelivered: 'WrongProductDelivered',
    ParcelNotDelivered: 'ParcelNotDelivered',
    ParcelDamaged: 'ParcelDamaged',
    ParcelRefused: 'ParcelRefused',
    InvoiceCampaignProductMissing: 'InvoiceCampaignProductMissing',
    InvoiceWrongPriceOrFee: 'InvoiceWrongPriceOrFee',
    CancelOrder: 'CancelOrder',
    RefundReturnCost: 'RefundReturnCost',
    WrongPriceFix: 'WrongPriceFix',
    SupplementaryProduct: 'SupplementaryProduct',
    ExtraProductReceivedMissingOnTheInvoice: 'ExtraProductReceivedMissingOnTheInvoice',
    ExtraProductReceivedWrongQuantity: 'ExtraProductReceivedWrongQuantity',
    UncollectedParcel: 'UncollectedParcel',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimCategoryDtoCategoryId = {
    Root: 'Root',
    ReturnExchangeMissing: 'ReturnExchangeMissing',
    DistributionIssue: 'DistributionIssue',
    InvoiceIssue: 'InvoiceIssue',
    Return: 'Return',
    Exchange: 'Exchange',
    Missing: 'Missing',
    WrongProductDelivered: 'WrongProductDelivered',
    ProductJustMissing: 'ProductJustMissing',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalClaimCategoriesClaimActionDtoActionId = {
    ReturnProduct: 'ReturnProduct',
    ExchangeProduct: 'ExchangeProduct',
    CancelProduct: 'CancelProduct',
    ResendProduct: 'ResendProduct',
    CancelOrder: 'CancelOrder',
    ResendOrder: 'ResendOrder',
    None: 'None',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCataloguesCatalogueOfferDtoType = {
    None: 'None',
    Buy: 'Buy',
    Get: 'Get',
    Choose: 'Choose',
    ChooseAndGet: 'ChooseAndGet',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCampaignsCampaignTransactionDtoTransaction = {
    Earn: 'Earn',
    Redeem: 'Redeem',
    Expired: 'Expired',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCampaignsCampaignStepScopeDtoScopeType = {
    Day: 'Day',
    Period: 'Period',
    Month: 'Month',
    Date: 'Date',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCampaignsCampaignStepScopeDtoBasedOn = {
    SignUpDate: 'SignUpDate',
    RecruitDate: 'RecruitDate',
    VipUpgradeDate: 'VipUpgradeDate',
    EcUpgradeDate: 'EcUpgradeDate',
    None: 'None',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCampaignsCampaignDtoType = {
    InvitedRecruits: 'InvitedRecruits',
    Loyalty: 'Loyalty',
    VipLoyalty: 'VipLoyalty',
    Mgm: 'Mgm',
    LightVipLoyalty: 'LightVipLoyalty',
    MmLoyalty: 'MmLoyalty',
    Gamification: 'Gamification',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalCampaignsCampaignDtoCategory = {
    Recruitment: 'Recruitment',
    Loyalty: 'Loyalty',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalBonusesPeriodTaskDtoResult = {
    Planned: 'Planned',
    Running: 'Running',
    PartiallyFinished: 'PartiallyFinished',
    Finished: 'Finished',
    Disabled: 'Disabled',
    Failed: 'Failed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalBlockingCodesBlockingCodeDtoBlockingType = {
    Login: 'Login',
    Recruit: 'Recruit',
    Order: 'Order',
    OrderOnCredit: 'OrderOnCredit',
    GetBonuses: 'GetBonuses',
    Claim: 'Claim',
    PayByCheque: 'PayByCheque',
    ApproveDocument: 'ApproveDocument',
    PageAccess: 'PageAccess',
    Other: 'Other',
    OnBehalf: 'OnBehalf',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDtoNotificationChannel = {
    Email: 'Email',
    Sms: 'Sms',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsSimplifiedRegistrationSimplifiedRegistrationConfigurationDtoRegistrationType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsSimplifiedRegistrationCustomerReferralDtoReferralType = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
    Pbs: 'Pbs',
    ReferralLink: 'ReferralLink',
    InternationalPbs: 'InternationalPbs',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsProfileProfileConfigurationDtoInitStatus = {
    None: 'None',
    SocialNetworkAlreadyConnected: 'SocialNetworkAlreadyConnected',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsProfileInternationalSectionConfigurationDtoSectionMode = {
    Disabled: 'Disabled',
    Limited: 'Limited',
    Full: 'Full',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsPersonalMenuPersonalMenuDtoUserType = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderSummaryOrderSummaryDiscountDtoType = {
    Direct: 'Direct',
    Staggered: 'Staggered',
    Voucher: 'Voucher',
    PromoCode: 'PromoCode',
    Employee: 'Employee',
    Merchandising: 'Merchandising',
    Extra: 'Extra',
    GiftCard: 'GiftCard',
    Invitation: 'Invitation',
    Immediate: 'Immediate',
    Welcome: 'Welcome',
    ProductVoucher: 'ProductVoucher',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoReferenceUniquePayment = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoTotalSales = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoPrepaidBalance = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoPdBalance = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoTotalCredit = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoRemainingCredit = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoDebtPenalty = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoTotalDebt = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoGroupBp = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoBv = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoPersonalBp = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoPhoneNumber = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoNameAndProfilePicture = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsOrderHistoryKpiVisibilityConfigurationDtoConsultantNumber = {
    Hide: 'Hide',
    Show: 'Show',
    ShowAlways: 'ShowAlways',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsMv7ConfigurationCheckoutRegistrationConfigurationDtoConsultantType = {
    Consultant: 'Consultant',
    VipCustomer: 'VipCustomer',
    DirectSeller: 'DirectSeller',
    SpoOwner: 'SpoOwner',
    Agent: 'Agent',
    Corporate: 'Corporate',
    LegacyConsultant: 'LegacyConsultant',
    LegacyManager: 'LegacyManager',
    FamilyContractor: 'FamilyContractor',
    LegacyDirector: 'LegacyDirector',
    Member: 'Member',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsMv7ConfigurationCheckoutRegistrationConfigurationDtoCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalApplicationsChatBotChatBotConfigurationDtoMode = {
    Disabled: 'Disabled',
    AlwaysEnabled: 'AlwaysEnabled',
    NonBusinessHoursOnly: 'NonBusinessHoursOnly',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalAddressesLookupAddressSuggestionDtoSuggestionType = {
    Path: 'Path',
    Address: 'Address',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalAddressesLookupAddressSearchResultDtoType = {
    Market: 'Market',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    Street: 'Street',
    ZipCode: 'ZipCode',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalAddressesLookupAddressNodeDtoType = {
    Market: 'Market',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    Street: 'Street',
    ZipCode: 'ZipCode',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalActivitiesCustomerActivityDtoFrequency = {
    Once: 'Once',
    Period: 'Period',
    Streak: 'Streak',
    Day: 'Day',
    Endless: 'Endless',
    Week: 'Week',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalActivitiesCustomerActivityDtoActivityCategory = {
    None: 'None',
    Explore: 'Explore',
    Share: 'Share',
    Spend: 'Spend',
    PerfectStart: 'PerfectStart',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalActivitiesCustomerActivityDtoActivityType = {
    CompleteProfile: 'CompleteProfile',
    Onboarding: 'Onboarding',
    LearningActivity: 'LearningActivity',
    BrowseCatalogue: 'BrowseCatalogue',
    DailyHearts: 'DailyHearts',
    SkinDiagnosis: 'SkinDiagnosis',
    VisitPage: 'VisitPage',
    VisitQuiz: 'VisitQuiz',
    VisitBanner: 'VisitBanner',
    VisitSocial: 'VisitSocial',
    Campaign2Order: 'Campaign2Order',
    FirstOrder: 'FirstOrder',
    WpOrder: 'WpOrder',
    Campaign3Order: 'Campaign3Order',
    Campaign4Order: 'Campaign4Order',
    Campaign5Order: 'Campaign5Order',
    Campaign6Order: 'Campaign6Order',
    PayRevolut: 'PayRevolut',
    SubscribeWellosophy: 'SubscribeWellosophy',
    SharingDiscount: 'SharingDiscount',
    ShareProduct: 'ShareProduct',
    ShareCatalogue: 'ShareCatalogue',
    SharingApp: 'SharingApp',
    SharePost: 'SharePost',
    ShareLink: 'ShareLink',
    RecruitOrder: 'RecruitOrder',
    RecruitWp: 'RecruitWp',
    FirstRecruit: 'FirstRecruit',
    RecruitWithProduct: 'RecruitWithProduct',
    TpsOnboarding: 'TpsOnboarding',
    TpsProgramPlus: 'TpsProgramPlus',
    TpsAdvancementBonus: 'TpsAdvancementBonus',
    TpsSummit: 'TpsSummit',
    TpsMyWhy: 'TpsMyWhy',
    NovAgePurchase: 'NovAgePurchase',
    ProductPurchase: 'ProductPurchase',
    OpenMv7: 'OpenMv7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalAccountsExternalProfileDtoExternalProvider = {
    Google: 'Google',
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    ActiveDirectory: 'ActiveDirectory',
    WeChat: 'WeChat',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GlobalAccountsAccountInfoDtoLoginStatus = {
    Allowed: 'Allowed',
    Maintenance: 'Maintenance',
    Terminated: 'Terminated',
    Blocked: 'Blocked',
    Temporary: 'Temporary',
};

